import { useCallback, useMemo, useRef } from "react";
import { useSearchParams, usePathname } from "next/navigation";
import { useAtomValue } from "jotai";
import { appVersionUpdateIsShowAtom, transferPackageIsShowAtom } from "@/store";
import { useChangeSubscription } from "@/hooks/use-change-subscription";
import useGlobalModal from "@/components/modal/hooks/useGlobalModal";
import { getNotificationFetchwithmark } from "../services/notice";
import VipUpgradeModal from "../components/modal-upgrade";

export default function VipUpgradeProvider() {
  // 获取当前路由信息
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { pushGlobalModal } = useGlobalModal();
  const appUpdateShow = useAtomValue(appVersionUpdateIsShowAtom);
  const transferPackageShow = useAtomValue(transferPackageIsShowAtom);
  // const [notifications, setNotifications] = useAtom(vipUpgradeNotificationAtom);
  const firstLoaded = useRef(true);

  const hasShowModal = useMemo(() => {
    return appUpdateShow || transferPackageShow;
  }, [appUpdateShow, transferPackageShow]);

  const pushVipUpgradeModal = useCallback((unread) => {
    pushGlobalModal({
      id: 'vipUpgrade',
      Comp: VipUpgradeModal,
      params: { notifications: unread }
    });
  }, [pushGlobalModal]);

  const fetchNotificationInfo = useCallback(() => {
    if (hasShowModal) {
      return;
    }
    getNotificationFetchwithmark({ params: { type: 'member_upgrade' } })
      .then(data => {
        if (data?.notifications) {
          // 未读且新版本的消息才弹出
          const unread = data?.notifications.filter((item) =>
            item.status === 0 && item.version === 'v2');
          if (unread.length > 0) {
            // if (hasShowModal) {
            //   setNotifications(unread); // 其他弹窗消失后由 useEffect 触发
            //   return;
            // }
            pushVipUpgradeModal(unread);
          }
        }
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        firstLoaded.current = false;
      });
  }, [hasShowModal, pushVipUpgradeModal]);

  /**
   * 检查是否在允许显示非强制弹窗的路由
   * 允许的路由：首页大厅、Casino子大厅、Casino容器详情
   * 个人中心：账户、交易记录、交易详情、游戏历史
   * VIP、代理、奖励中心详情页、活动中心列表页
   */
  const isAllowedRouteForNonForce = useCallback(() => {
    // 移除语言前缀，统一处理路由（如 /en/ -> /）
    const pathWithoutLocale = pathname.replace(/^\/(en|pt|hi|id|es|tr|vi)/, '') || '/';

    if ([
      '/vip', '/affiliate', '/reward',
      '/account', '/transaction-history', '/game-history',
      '/casino', '/casino/games/container',
      '/promotions'
    ].includes(pathWithoutLocale)) {
      return true;
    }

    // 只有在根路径下才允许
    if (pathWithoutLocale !== '/' && pathWithoutLocale !== '') {
      return false;
    }

    // 检查 menuTab 参数
    const menuTab = searchParams?.get('menuTab');

    // 允许：无 menuTab、menuTab=Explore、menuTab=Casino
    return !menuTab || menuTab === 'Explore' || menuTab === 'Casino';
  }, [pathname, searchParams]);

  useChangeSubscription('upgrade_reward_popup', () => {
    if (isAllowedRouteForNonForce() && !hasShowModal) {
      // if (firstLoaded.current && isInApp()) {
      //   setTimeout(() => {
      //     fetchNotificationInfo();
      //   }, 2000);
      // } else {
      //   fetchNotificationInfo();
      // }
      fetchNotificationInfo();
    }
  });

  // useEffect(() => {
  //   if (!hasShowModal && notifications?.length > 0) {
  //     pushVipUpgradeModal(notifications);
  //     setNotifications([]);
  //   }
  // }, [notifications, setNotifications, pushVipUpgradeModal, hasShowModal]);

  return null;
}